import { currencyFormatter } from '@magalu/stereo-ui-utils';

const moneyMask = value => {
  let parsedValue = value;

  if (typeof value === 'string') {
    parsedValue = value.replace('.', '').replace(',', '').replace(/\D/g, '');
  }

  const currentValue = Number.isNaN(parsedValue) || parsedValue === '' ? 0 : parsedValue;
  const currencyValue = currencyFormatter({
    value: currentValue,
    rightFilling: true
  });
  return {
    amount: currentValue,
    currency: currencyValue
  };
};

export default moneyMask;